/**
 * Worklist tab values from `GET /eligibility/options` (`EligibilityTab` on the API).
 */

import type { EligibilitySelectOption } from "../data-model/eligibilityOptions";

/** Screened-rows `tab` filter for archived patients. */
export const ELIGIBILITY_ARCHIVE_TAB_VALUE = "Archive Patients";

/** Worklist tab that intentionally retains patients without an eligibility tier. */
export const ELIGIBILITY_INELIGIBLE_TAB_VALUE = "Ineligible";

const ELIGIBILITY_EMPTY_STATE_TEXT: Readonly<Record<string, string>> = {
  "To be Reviewed": "No Patients To be reviewed",
  "Pre Screening": "No Patients Under Prescreening",
  "Under Screening": "No Patients Under Screening",
  Recruited: "No Patients Recruited",
  [ELIGIBILITY_INELIGIBLE_TAB_VALUE]: "No Ineligible Patients",
};

/** Tabs removed from the horizontal strip and opened via Archive Patients instead. */
export const ELIGIBILITY_HIDDEN_WORKLIST_TAB_VALUES = new Set<string>([
  ELIGIBILITY_ARCHIVE_TAB_VALUE,
  "Blacklisted",
]);

/**
 * Tabs shown in the main worklist navigation (excludes archive and blacklisted).
 *
 * @param tabs - Full tab list from the options API
 * @returns Tabs for {@link PatientEligibilityMappingNavigation}
 */
export function filterWorklistNavigationTabs(
  tabs: EligibilitySelectOption[],
): EligibilitySelectOption[] {
  return tabs.filter(
    (tab) => !ELIGIBILITY_HIDDEN_WORKLIST_TAB_VALUES.has(tab.value),
  );
}

/**
 * Resolve the patient-focused empty-state copy for a worklist tab.
 *
 * @param tabValue - Server-provided Eligibility tab value
 * @returns Custom empty-state copy, or undefined for non-worklist tabs
 */
export function getEligibilityEmptyStateText(
  tabValue: string,
): string | undefined {
  return ELIGIBILITY_EMPTY_STATE_TEXT[tabValue];
}
